export const RoutesApps = [
  {
    regex: /^\/apps\/analytics\/?$/,
    title: 'Dashboard',
  },
  {
    regex: /^\/apps\/calendar\/?$/,
    title: 'Agenda',
  },
  {
    regex: /^\/apps\/manage-account\/?$/,
    title: 'Gerenciar Conta',
  },
  {
    regex: /^\/apps\/faq\/?$/,
    title: 'Central de Ajuda',
  },
  {
    regex: /^\/apps\/contact\/?$/,
    title: 'Entrar em Contato',
  },
  {
    regex: /^\/apps\/notifications\/?$/,
    title: 'Notificações',
  },
]
export default [

]
